<template>
	<div class="hello">
		<navigationbar :parentToChild="name" v-if="show"></navigationbar>
		<div :class="show ? 'content-box' : ''">
		  <div class="product" v-show="contents.length > 0">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, index) in contents" :key="index">
              <div v-if="item.typeId === 1">
                <a :href="item.picturesLink"><img class="imageUrl" :src="item.imageUrl"></a>
              </div>
              <div v-else-if="item.typeId === 2" class="videoComponent">
                <video v-if="isDisplay || !item.imageUrl" class="video listen-video" controls autoplay :src="item.videoUrl"></video>
                <div v-else class="videoCover">
                  <div class="playButton" @click="isDisplayEvent"></div>
                  <img class="imageUrl" :src="item.imageUrl" @click="previewImg(item.imageUrl)" />
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
      </div>
      <div v-if="recipeFlag === 0">
        <div class="vtabs-box" v-if="subcatalogType === 1">
          <!--v-if="catalogList.length > 3"-->
          <div class="vtabs-more" @click="isTabChange">
            <img v-if="isTabMore" src="../assets/img/icon-nomore.png" />
            <img v-else src="../assets/img/icon-more.png" />
          </div>
          <ul class="vtab-ul" v-if="!isTabMore">
            <li class="vtab-li" v-for="(item, index) in catalogList" @click="getActiveName(index)" :key="index">{{ item.catalogContentName }}</li>
          </ul>
          <van-tabs class="vtabs" v-model="active" :swipe-threshold="2" @click="tagClick" sticky>
            <van-tab v-for="(item, index) in catalogList" :key="index" :title="item.catalogContentName">
              <div v-if="index === active" class="tab-content">
                <p class="note-info-title" v-if="item.hasOwnProperty('note') && item.note !== '' && item.note !== null">{{item.noteTitle || '注意事项'}}</p>
                <p class="note-info" v-if="item.hasOwnProperty('note') && item.note !== '' && item.note !== null" v-html="item.note"></p>
                <div v-if="item.hasOwnProperty('contents')" class="content-info">
                  <div v-for="(subItem, subIndex) in item.contents" :key="subItem.id">
                    <img v-if="subItem.typeId === 1" class="content-info-img" :src="subItem.imageUrl" @click="previewImg(subItem.imageUrl)" alt="" />
                    <video v-else-if="subItem.typeId === 2" ref="listenvideo" class="content-info-video" controls :src="subItem.videoUrl" :index="index" :id="subItem.id"></video>
                    <pdfbox v-else :tabIndex="index" :subIndex="subIndex" :pdfUrl="subItem.imageUrl"></pdfbox>
                    <div class="content-remark">{{ subItem.remark }}</div>
                  </div>
                </div>
                <div class="evaluatediv">
                  <span class="sendbutton" @click="sendEvent(index,'ic_h5_resolveClick')">
                     <img class="btnicon" src="../assets/img/icon/icon-good.png" />
                     <img class="btnicon" style="display:none" src="../assets/img/icon/icon-good-choose.png" />
                    已解决
                  </span>
                  <span  class="sendbutton" @click="sendEvent(index,'ic_h5_unresolveClick')">
                     <img class="btnicon" src="../assets/img/icon/icon-bad.png" />
                     <img class="btnicon" style="display:none" src="../assets/img/icon/icon-bad-choose.png" />
                    未解决
                  </span>
                </div>
              </div>
            </van-tab>
          </van-tabs>
        </div>
        <div v-else>
          <!-- 纵向 -->
          <van-collapse v-model="activeName" accordion>
            <van-collapse-item v-for="(item, index) in catalogList" :key="index" :title="item.catalogContentName" :name="index+'accordion'">
              <div class="tab-content">
                <p class="note-info-title" v-if="item.hasOwnProperty('note') && item.note !== '' && item.note !== null">{{item.noteTitle || '注意事项'}}</p>
                <p class="note-info" v-if="item.hasOwnProperty('note') && item.note !== '' && item.note !== null" v-html="item.note"></p>
                <div v-if="item.hasOwnProperty('contents')" class="content-info">
                  <div v-for="(subItem, subIndex) in item.contents" :key="subItem.id">
                    <img v-if="subItem.typeId === 1" class="content-info-img" :src="subItem.imageUrl" @click="previewImg(subItem.imageUrl)" alt="" />
                    <video v-else-if="subItem.typeId === 2" ref="listenvideo" class="content-info-video" controls :src="subItem.videoUrl" :index="index" :id="subItem.id"></video>
                    <pdfbox v-else :tabIndex="index" :subIndex="subIndex" :pdfUrl="subItem.imageUrl"></pdfbox>
                    <div class="content-remark">{{ subItem.remark }}</div>
                  </div>
                </div>
              </div>
               <div v-if="activeName === index+'accordion'" class="evaluatediv">
                  <span class="sendbutton" @click="sendEvent(index,'ic_h5_resolveClick')">
                     <img class="btnicon" src="../assets/img/icon/icon-good.png" />
                     <img class="btnicon" style="display:none" src="../assets/img/icon/icon-good-choose.png" />
                    已解决
                  </span>
                  <span  class="sendbutton" @click="sendEvent(index,'ic_h5_unresolveClick')">
                     <img class="btnicon" src="../assets/img/icon/icon-bad.png" />
                     <img class="btnicon" style="display:none" src="../assets/img/icon/icon-bad-choose.png" />
                    未解决
                  </span>
                </div>
            </van-collapse-item>
          </van-collapse>
        </div>
      </div>
      <div v-else>
        <ul class="recipe-ul">
          <li class="recipe-li" v-for="(item, index) in recipeList" @click="recipeDetail(item.recipeId)" :key="index + 'recipe'">
            <div class="recipe-img-box">
              <img class="recipe-img" :src="item.thumbnailUrl" @click="previewImg(item.thumbnailUrl)" alt="" />
            </div>
            <div class="recipe-title">{{ item.recipeName }}</div>
            <div class="recipe-detail">{{ item.costTimeHr * 60 + item.costTimeMin + '分钟/' + difficultyList[item.difficulty - 1] + item.kcal + '大卡' }}</div>
          </li>
        </ul>
      </div>
		</div>
		<van-image-preview v-model="preViewShow" :images="previewImages"></van-image-preview>
	</div>
</template>


<script>
//  import  '@/components/common/webVIew'
import navigationbar from "@/components/navigationbar";
import pdfbox from "@/components/pdfbox";
import getGoodsId from "@/components/common/getGoodsId";
import axios from "axios";
import Swiper from "@/../static/swiper.min.js";
import "@/../static/swiper.min.css";
import apiConfig from "../api";

export default {
	name: "",
	data() {
		return {
		  isTabMore: true,
		  active: 0,
		  difficultyList: ['简单/', '较简单/', '中等/', '较困难/', '困难/'],
		  isDisplay: false,
		  activeName: '',
		  subcatalogType: 1, // 1横向，2纵向
			catalogList: [],
			contents: [],
			name: "说明书",
			show: false,
			from: "",
			recipeFlag: 0,
			recipeList: [],
			catalogContentName: '',
      duringtimer:'',
      preViewShow: false,
      previewImages: [],
		};
	},
	methods: {
	  previewImg(imgUrl) {
      this.preViewShow = true;
      this.previewImages = [];
      this.previewImages.push(imgUrl);
    },
	  tagClick() {
	    if (this.$refs.listenvideo) {
	      this.$refs.listenvideo.forEach(item => {
          if (!item.paused) {
            item.pause()
          }
        })
	    }
	  },
    listenVideo(){
      const videos=this.$refs.listenvideo;
      if(videos){
        videos.forEach(video=>{
          if(video.currentTime>1){
            const index=video.getAttribute('index');
            const videoId=video.getAttribute('id');
            window.collectEvent('beconEvent','ic_h5_videoClick',{videoId:videoId,lv2CatalogContentid:this.catalogList[index].id,lv2CatalogContentName:this.catalogList[index].catalogContentName});
            window.collectEvent('beconEvent','ic_h5_videoDuration',{videoDuration:video.currentTime,videoId:videoId,lv2CatalogContentid:this.catalogList[index].id,lv2CatalogContentName:this.catalogList[index].catalogContentName});
          }
      })
      }

    },
    sendEvent(index,eventName){
      if(eventName==='ic_h5_resolveClick'||eventName==='ic_h5_unresolveClick'){
        this.changeButtonstatus(index,eventName);
      }
        window.collectEvent(eventName,{lv2CatalogContentid:this.catalogList[index].id,lv2CatalogContentName:this.catalogList[index].catalogContentName});

    },
    changeButtonstatus(tempIndex,eventName){
      console.log('index...', tempIndex);
      const index = 0;
      const btns=document.getElementsByClassName('evaluatediv');
      if(eventName==='ic_h5_resolveClick'){
        btns[index].children[0].classList.add('spanDisableChoose');
        btns[index].children[0].getElementsByClassName('btnicon')[0].setAttribute('style','display:none');
        btns[index].children[0].getElementsByClassName('btnicon')[1].setAttribute('style','display:block');
        btns[index].children[1].classList.add('spanDisable');
        btns[index].children[1].getElementsByClassName('btnicon')[0].setAttribute('style','display:block');
        btns[index].children[1].getElementsByClassName('btnicon')[1].setAttribute('style','display:none');
      }else{
        btns[index].children[0].classList.add('spanDisable');
        btns[index].children[0].getElementsByClassName('btnicon')[0].setAttribute('style','display:block');
        btns[index].children[0].getElementsByClassName('btnicon')[1].setAttribute('style','display:none');
        btns[index].children[1].classList.add('spanDisableChoose');
        btns[index].children[1].getElementsByClassName('btnicon')[0].setAttribute('style','display:none');
        btns[index].children[1].getElementsByClassName('btnicon')[1].setAttribute('style','display:block')
      }

    },
	  getActiveName(index) {
	    this.active = index;
	    this.isTabMore = true;
	  },
	  isTabChange() {
	    this.isTabMore = !this.isTabMore;
	  },
	  recipeDetail(recipeId) {
	    const recipeUrl = "https://www.smartmidea.net/activity/sit/recipe/index.html#/detail?recipeId=" + recipeId; // sit环境
	    // const recipeUrl = "https://www.smartmidea.net/recipe/index.html#/detail?recipeId=" + recipeId; // prod环境
	    window.location.href = recipeUrl;
	  },
	  isDisplayEvent() {
      this.isDisplay = !this.isDisplay;
    },
	},
	created() {
	  this.name = this.$route.params.name ? this.$route.params.name : '说明书'
	  // document.title = this.name;
	  if (!(/meiju|msmart/.test(navigator.userAgent.toLowerCase()))) {
      document.title = this.name;
    }
		const url = apiConfig.serverAddress + "msInstruction/clickInstructions?apikey=" + process.env.apikey;

		this.from = getGoodsId("from");
    if (this.$route.params.id) {
      const restParams = {
        instructionsId: this.$route.params.id   // this.$route.params.id 152011
      }
      const headers = {
        'Content-Type': "application/json",
        __TokenAuthorization_UserName_:'admin',
        __TokenAuthorization_Function_:'refreshClassificationLevelAndSort'
      }
      axios.post(url, {'restParams':restParams, headParams: {"userKey": "TEST_"}}, {headers: headers}).then(response => {
      	if (response.data.data) {
      	  this.catalogContentName = response.data.data.catalogContentName;
      	  this.recipeFlag = response.data.data.recipeFlag;
      	  if (this.recipeFlag === 0) {
      	    this.catalogList = response.data.data.children;
            if (this.catalogList.length === 1) {
              this.activeName = '0accordion';
            }
            this.contents = Object.prototype.hasOwnProperty.call(response.data.data, 'contents') ? response.data.data.contents : [];
            this.subcatalogType = response.data.data.subcatalogType;
            this.sendEvent(0,'ic_h5_detailPV');
      	  } else {
      	    this.recipeList = response.data.data.recipeList;
      	  }
      	  this.duringtimer=new Date();
      	}
      })
      .catch(() => {
      	console.log("网络错误，不能访问");
      });
    }

	},
	mounted() {
		//判断访问终端
		const browser = {
			versions: (function() {
				const u = navigator.userAgent;
				return {
					trident: u.indexOf("Trident") > -1, //IE内核
					presto: u.indexOf("Presto") > -1, //opera内核
					webKit: u.indexOf("AppleWebKit") > -1, //苹果、谷歌内核
					gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") === -1, //火狐内核
					mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
					ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
					android: u.indexOf("Android") > -1 || u.indexOf("Adr") > -1, //android终端
					iPhone: u.indexOf("iPhone") > -1, //是否为iPhone或者QQHD浏览器
					iPad: u.indexOf("iPad") > -1, //是否iPad
					webApp: u.indexOf("Safari") === -1, //是否web应该程序，没有头部与底部
					weixin: u.indexOf("MicroMessenger") > -1, //是否微信 （2015-01-22新增）
					hongmeng: u.indexOf("MideaOpenHormanyNext") > -1,
					qq: u.match(/\sQQ/i) === " qq" //是否QQ
				};
			})(),
			language: (navigator.browserLanguage || navigator.language).toLowerCase()
		};

    if (browser.versions.hongmeng) {
      this.show = true;
    }
		if (browser.versions.android) {
			this.show = true;
		}
		if (browser.versions.ios && this.from !== "control") {
			this.show = true;
		}
		if (browser.versions.iPad && this.from !== "control") {
			this.show = true;
		}
		if (browser.versions.iPhone && this.from !== "control") {
			this.show = true;
		}
		const program = getGoodsId("program");
    if (this.from === "weex" || program === 'miniColmo') {
      this.show = false;
    }
		// 是否是美居app
		if (/meiju|msmart/.test(navigator.userAgent.toLowerCase())) {
			this.show = false;
		}
		console.log('program...:', program);
		console.log('this.show...:', this.show);
		//swiper
		const _this = this;
		new Swiper(".swiper-container", {
			pagination: {
				el: ".swiper-pagination"
			},
			loop : false,
      speed:2000,
      autoplay:true,
      observer: true,
      observeParents: true,
      on: {
        slideChangeTransitionEnd: function(){
          if(_this.isDisplay) {
            _this.isDisplayEvent()
          }
        },
      },
		});
	},
  beforeDestroy(){
    this.listenVideo();
    const now=new Date();
    window.collectEvent('beconEvent','ic_h5_detailDuration',{duration:now-this.duringtimer,lv2CatalogContentid:this.catalogList[this.active].id,lv2CatalogContentName:this.catalogList[this.active].catalogContentName});
		this.duringtimer=''

  },
  watch: {
    active(newIndex,index){
      const now=new Date();
      window.collectEvent('ic_h5_detailDuration',{duration:now-this.duringtimer,lv2CatalogContentid:this.catalogList[index].id,lv2CatalogContentName:this.catalogList[index].catalogContentName});
      this.duringtimer=now;
      this.sendEvent(newIndex,'ic_h5_detailPV');
    },
  },
	components: {
		navigationbar,
		Swiper,
		pdfbox
	}
};
</script>

<style scoped>
.content {
	margin-top: 1.333333rem;
}
.product {
  display: flex;
  align-items: center;
  border: 1px solid #e8e8e8;
  background: #ffffff;
  height: 400px;
  overflow: hidden;
  margin-top: 10px;
}
/deep/ .van-tab{
  font-size: 30px;
  line-height: 80px;
}
/deep/ .van-tab__text{
  display: inline-block;
  min-width: 150px;
  text-align: center;
  overflow: hidden;
  padding-right: 90px;
  white-space:nowrap;
}
/deep/ .van-tab--active{
  color: #267afe;
}
/deep/ .van-tabs__line {
  width: 50px !important;
  height: 6px;
  background-color: rgb(38, 122, 254);
  margin-left: -7%;
  transition-duration: 0.3s;
}
/deep/ .van-cell__title{
  font-size: 30px;
  line-height: 80px;
  font-weight: 700;
  padding-left: 10px;
}
/deep/ .van-icon{
  top: 30px;
  margin-right: 10px;
}
.tab-content{
  width: 100%;
}
.title-info{
 margin-top: 100px;
  width: 90%;
  margin-left: 5%;
  text-align: center;
}
.title-span{
  color: #000000;
  font-size: 50px;
  font-weight: 700;
  position: relative;
}
.title-span::after{
  content: "";
  position: absolute;
  bottom: -15px;
  left: -10%;
  width: 120%;
  height: 30px;
  border-radius: 10px;
  background: rgba(0,145,255,.2);
}
.note-info-title {
  margin-top: 20px;
  width: 100%;
  text-align: center;
  font-size: 40px;
  font-weight: 600;
  color: #2C9ED6;
}
.note-info{
  width: 90%;
  margin-top: 20px;
  margin-left: 5%;
  background: #f2f2f2;
  border-radius: 15px;
  padding: 15px;
}
.content-info{
  width: 94%;
  margin-top: 40px;
  margin-left: 3%;

}
.content-info-img, .content-info-video{
  width: 100%;
  border-radius: 10px;
}
.content-remark{
  width: 100%;
  margin-top: 30px;
  font-size: 30px;
  color: #000000;
  line-height: 45px;
  font-weight: 200;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.swiper-container {
	width: 710px;
  min-height: 400px;
	background: #ffffff;
}

.swiper-slide img {
	width: 100%;
}

.swiper-slide {
	text-align: center;
	font-size: 18px;
	background: #ffffff;
	display: -ms-flexbox;
	display: flex;
	-ms-flex-pack: center;
	justify-content: center;
	-ms-flex-align: center;
	align-items: center;
}
.videoComponent{
  width: 100%;
  position: relative;
  background: #ffffff;
}
.video{
  width: 100%;
  max-width: 100%;
  height: auto;
  max-height: 400px;
  display: block;
  object-fit: contain;
}
.videoCover{
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  overflow: hidden;
  z-index: 10;
}
.playButton{
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
  width: 1.28rem;
  height: 1.28rem;
  z-index: 99;
  background: url(../assets/img/open.png) no-repeat;
  background-size: 100% 100%;
}
.recipe-ul {
  width: 100%;
  margin: 20px 0 0 0;
  padding: 0;
  list-style: none;
  overflow: hidden;
}
.recipe-li {
  width: 49%;
  float: left;
  overflow: hidden;
  margin-bottom: 15px;
}
.recipe-img-box {
  width: 100%;
}
.recipe-img {
  width: 96%;
  margin-left: 4%;
  border-radius: 8px;
}
.recipe-title {
  width: 96%;
  margin-left: 4%;
  height: 48px;
  line-height: 48px;
  font-family: PingFangSC-Regular;
  font-size: 32px;
  color: #333333;
  letter-spacing: 0;
  font-weight: 400;
  overflow: hidden;
}
.recipe-detail {
  width: 96%;
  margin-left: 4%;
  height: 36px;
  font-family: PingFangSC-Regular;
  font-size: 24px;
  color: #999999;
  letter-spacing: 0;
  line-height: 36px;
  font-weight: 400;
}
.evaluatediv{
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
  padding: 20px 0;
}
.sendbutton{
  background: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 1rem;
  line-height: 0.7rem;
  border: 1px solid #909399;
  border-radius: 0.5rem;
  margin: 0 0.9rem;
}
.spanDisable{
  opacity: 0.5;
  border: 0.5px solid #909399;
  pointer-events:none;
}
.spanDisableChoose{
  opacity: 0.5;
  border: 0.5px solid #409EFF;
  pointer-events:none;
}
.btnicon{
    width: 0.5rem;
    height: 0.5rem;
    display: inline-block;
    margin-right: 5px;
}
.vtabs-box {
  position: relative;
}
.vtabs-more {
  position: absolute;
  z-index: 101;
  height: 80px;
  width: 80px;
  line-height: 80px;
  right: 1px;
  top: 0;
  background: #ffffff;
}
.vtabs-more img {
  width: 50px;
  height: 50px;
  margin-left: 15px;
  margin-top: 15px;
}
.vtab-ul {
  position: fixed;
  left: 0;
  right: 0;
  top: 580px;
  bottom: 0;
  width: 100%;
  background: #ffffff;
  z-index: 100;
  border-top: 1px solid #999999;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  padding: 0;
  margin: 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 15%);
}
.vtab-li {
   padding: 0;
   margin: 0;
   list-style: none;
   height: 80px;
   line-height: 80px;
   padding-left: 20px;
   font-size: 30px;
   color: #999999;
   border: 1px solid #999999;
   border-top: 0;
}
.content-box {
  margin-top: 100px;
}
.imageUrl{
  width: 100%;
  height: auto;
  max-height: 400px;
  object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// src/components/instruction.vue